export const GOOGLE_TAG_MANAGER_ATTRIBUTES = {
  // Customer
  customerId: 'dimension11',

  // Product
  productBrand: 'brand',
  productCategory: 'category',
  productId: 'id',
  productVariant: 'variant',
  productVertical: 'vertical',
  productSkuUuid: 'sku_uuid',
  productVariantSize: 'variantSize',
  productMarket: 'market',
};
